import { render, staticRenderFns } from "./SingleVideo.vue?vue&type=template&id=57924608"
import script from "./SingleVideo.vue?vue&type=script&lang=js"
export * from "./SingleVideo.vue?vue&type=script&lang=js"
import style0 from "./SingleVideo.vue?vue&type=style&index=0&id=57924608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports